<div style="padding: 0px 10px">
    <kendo-toolbar #toolbar size="medium">
        <app-custom-tool-bar [items]="items">

        </app-custom-tool-bar>
    </kendo-toolbar>
</div>

